var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirportIconDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00297165 9.75461C0.019453 9.61215 0.105274 9.48749 0.232389 9.42105L0.249395 9.41307C0.288582 9.39667 1.21502 9.01148 1.78274 8.93179C1.89039 8.91662 2.00365 8.93775 2.10745 8.98974L4.01406 9.66528C4.38602 9.47399 5.79628 8.74936 7.45753 7.90182L3.53042 5.83276C3.41496 5.77192 3.34772 5.6676 3.35079 5.55372C3.35377 5.43993 3.42636 5.33938 3.54497 5.28477L4.8687 4.67427C4.99573 4.61571 5.19762 4.59257 5.33727 4.62237L11.3701 5.91876C12.6115 5.29573 13.636 4.79052 14.0632 4.60169C14.3768 4.46309 14.7581 4.39322 15.1963 4.39322C15.9194 4.39322 16.8041 4.60107 16.9676 4.90781C16.974 4.91956 17.4057 6.20016 14.9127 7.6333L5.61561 12.371C5.60631 12.3753 5.38461 12.4863 5.16896 12.5242C4.80401 12.5883 4.40882 12.6069 4.00232 12.6069H3.88449C3.82813 12.6069 3.77272 12.6069 3.71828 12.6069H3.68155V12.5939C3.41856 12.5939 3.22534 12.4801 3.19431 12.4586L0.15349 10.1409L0.146303 10.1322C0.0380363 10.0386 -0.0133343 9.89759 0.00297165 9.75461ZM3.68181 12.3603H3.68173V12.3617L3.68181 12.3603Z",
    fill: "#20202A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportIconDropdown);
export default __webpack_public_path__ + "static/media/airport-icon_dropdown.efa33403bfff3918dde648b500d33b17.svg";
export { ForwardRef as ReactComponent };